import { io } from 'socket.io-client';

let socket;

export const getSocket = (id) => {
    if (!socket || socket.disconnected) {
        // eslint-disable-next-line no-undef
        socket = io(process.env.REACT_APP_SOCKET_URL, {
            path: '/socket.io',
            query: { user_id: id },
            autoConnect: false, // Automatically connect to the socket server
            transports: ['websocket'], // Use WebSocket as the transport method
            withCredentials: true,
            reconnection: true,
            reconnectionAttempts: Infinity, // Keep trying to reconnect
            reconnectionDelay: 1000, // Start with 1 second delay
            reconnectionDelayMax: 5000, // Maximum 5 seconds delay
            randomizationFactor: 0.5, // Randomize reconnection timing
            timeout: 20000, // Connection timeout (20 seconds)
        });

        // Add error handling
        socket.on('connect_error', (err) => {
            console.error('Socket connection error:', err);
            // Implement your error handling (e.g., show notification)
        });

        socket.on('reconnect_attempt', (attempt) => {
            console.log(`Reconnection attempt ${attempt}`);
        });

        socket.on('reconnect_failed', () => {
            console.log('Reconnection failed');
        });

        socket.on('disconnect', (reason) => {
            console.log('Socket disconnected:', reason);
            if (reason === 'io server disconnect') {
                // The server forcibly disconnected, may need to reconnect manually
                setTimeout(() => socket.connect(), 1000);
            }
        });
    }

    return socket;
};

export const connectSocket = (userid) => {
    const socket = getSocket(userid);
    if (!socket.connected) {
        socket.connect();
    }
    return socket;
};

export const disconnectSocket = () => {
    if (socket?.connected) {
        socket.disconnect();
    }
};

export const updateSocketUserId = (newUserId) => {
    if (socket) {
        socket.io.opts.query.userId = newUserId;
        // If you need to reconnect with new userId
        if (socket.connected) {
            socket.disconnect().connect();
        }
    }
};

export default socket;
